
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 767 243","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0c68.416 172.083 235.094-24.813 385.749 70.895 45.753 29.066 237.4 36.316 282.847 65.859C722.207 171.604 755.008 208.019 767 246","stroke":"#006CB5","stroke-linecap":"round","stroke-linejoin":"round","stroke-dasharray":"0,5"}}),_c('circle',{attrs:{"fill":"#006CB5","cx":"588","cy":"114","r":"6"}})])])
          )
        }
      }
    